// This list is the response of the RD endpoint: /api/view-models/subscription-ranking-list
// and contains an ordered list of all offerings sorted by their ranking for family discounts
// (the higher the index in the list, the more expensive the offering is).
// It is hardcoded to avoid doing extra call every time family discounts are calculated.
// It should be updated when new subscriptions are added, or if there is a price change which could affect the order.

import { PricePlanDiscountGroup } from "../server/utils/rapidOrderUtils";

interface SubscriptionRankingItem {
    discountGroup: PricePlanDiscountGroup;
    monthlyPrice: number;
    offeringCode: string;
}

// NB: When updating list make sure the offering codes for 'TELIA_X_KAMPANJE_2026_2'
//     have lower rank than 'TELIA_X_START_2026' codes.
export const SUBSCRIPTION_RANKING: SubscriptionRankingItem[] = [
    {
        offeringCode: "TELIA_JUNIOR_01GB.COM12LOUDSPEAKER2",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50.REGULAR",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB.REGULAR",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50.COM12PURP15",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50.COM12PURP10",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50.COM12PURP25",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50.COM12PURP20",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50.COM12PURP30",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50.DATA1GBA",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB.DATA1GBA",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50.TLF12PLEAS",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB.TLF12PLEAS",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50.COM12LOUDSPEAKER2",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },

    //SUMMER CAMPAIGN JUNIOR 1GB
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50_2026.REGULAR",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB+PROMO_JR06_50_2026.COM12PLEAS",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    // End of summer campaign junior 1GB
    {
        offeringCode: "TELIA_JUNIOR_01GB.COM12PURP20",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB.COM12PURP15",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB.COM12PURP30",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB.COM12PURP25",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_01GB.COM12PURP10",
        monthlyPrice: 129,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_KLOKKE_01GB.COM00XPLORA",
        monthlyPrice: 159,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_KLOKKE_01GB.COM00WLEAS",
        monthlyPrice: 159,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_KLOKKE_01GB.COM12LOUDSPEAKER2",
        monthlyPrice: 159,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_KLOKKE_01GB.REGULAR",
        monthlyPrice: 159,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_KLOKKE_01GB.COM12LOUDSPEAKER2_XPLORA",
        monthlyPrice: 159,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB+PROMO_JR06_50.COM12LOUDSPEAKER2",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB.COM12LOUDSPEAKER2",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB.REGULAR",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB+PROMO_JR06_50.REGULAR",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB+PROMO_JR06_50.TLF12PLEAS",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB.COM12PURP10",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB.COM12PURP15",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB.COM12PURP20",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB.COM12PURP25",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB.COM12PURP30",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB.TLF12PLEAS",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB+PROMO_JR06_50.DATA1GBA",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB.DATA1GBA",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB+PROMO_JR06_50.COM12PURP30",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB+PROMO_JR06_50.COM12PURP25",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB+PROMO_JR06_50.COM12PURP20",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB+PROMO_JR06_50.COM12PURP15",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_03GB+PROMO_JR06_50.COM12PURP10",
        monthlyPrice: 179,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "SMART_SENIOR_500MB_2025.REGULAR",
        monthlyPrice: 219,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "SMART_SENIOR_500MB_2025.TLF12PLEAS",
        monthlyPrice: 219,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026.REGULAR",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026.TLF12PLEAS",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026.COM12PURP30",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026.COM12PURP20",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026.COM12PURP25",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026.COM12PURP10",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026.COM12PURP15",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026.DATA1GBA",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    // Summer campaign junior 10GB
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026+PROMO_JR06_50_2026.REGULAR",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026+PROMO_JR06_50_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_JUNIOR_10GB_2026+PROMO_JR06_50_2026.COM12PLEAS",
        monthlyPrice: 229,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_01GB_2027.REGULAR",
        monthlyPrice: 249,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_01GB_2027.TLF12PLEAS",
        monthlyPrice: 249,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.REGULAR",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.TLF12PLEAS",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.COM00ANSATT",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.COM00WLEAS",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.COM12LOUDSPEAKER2",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.COM12PURP10",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.COM12PURP15",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.COM12PURP20",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.COM12PURP25",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.COM12PURP30",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_03GB_2027.DATA1GBA",
        monthlyPrice: 299,
        discountGroup: "MHS_B2C",
    },
    // End of summer campaign junior 10GB
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG.DATA1GBA",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG.COM00WLEAS",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.COM12ANSATT",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.REGULAR",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.DATA1GBA",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.COM12PURP10",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.COM12PURP15",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.COM12PURP20",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.COM12PURP25",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.COM12PURP30",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG.COM12LOUDSPEAKER2",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.COM00WLEAS",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG.COM12PURP10",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG.COM12PURP15",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG.REGULAR",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG.COM12PURP20",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG.COM12PURP25",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG.COM12PURP30",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.COM12LOUDSPEAKER2",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG.TLF12PLEAS",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025.TLF12PLEAS",
        monthlyPrice: 329,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.COM00WLEAS",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG_2026.COM12PURP15",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG_2026.COM12PURP10",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG_2026.COM12PURP25",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG_2026.COM12PURP20",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG_2026.COM12PURP30",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.COM12LOUDSPEAKER2",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.TLF12PLEAS",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG_2026.TLF12PLEAS",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.COM12PURP30",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.COM12PURP20",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.COM12PURP25",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.COM12PURP10",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.COM12PURP15",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG_2026.REGULAR",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.REGULAR",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.COM12ANSATT",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2025_2.DATA1GBA",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG_2026.DATA1GBA",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_UNG_2026.COM00WLEAS",
        monthlyPrice: 349,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.COM00WLEAS",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.REGULAR",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.DATA1GBA",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.COM12PURP30",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.COM12PURP10",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.COM12PURP15",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.COM12PURP20",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.COM12PURP25",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.TLF12PLEAS",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.COM00ANSATT",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_05GB_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 369,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.COM12PURP10",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.COM12PURP15",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.COM12PURP30",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.COM12PURP20",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.COM12PURP25",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.COM00WLEAS",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.REGULAR",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.DATA1GBA",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.COM12LOUDSPEAKER2",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.TLF12PLEAS",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025.COM12ANSATT",
        monthlyPrice: 379,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_16GB_UNG.REGULAR",
        monthlyPrice: 389,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_16GB_UNG.COM12PURP10",
        monthlyPrice: 389,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_16GB_UNG.COM12PURP15",
        monthlyPrice: 389,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_16GB_UNG.COM12PURP20",
        monthlyPrice: 389,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_16GB_UNG.COM12PURP25",
        monthlyPrice: 389,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_16GB_UNG.COM12PURP30",
        monthlyPrice: 389,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_16GB_UNG.DATA1GBA",
        monthlyPrice: 389,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.TLF12PLEAS",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG.COM12LOUDSPEAKER2",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.COM12ANSATT",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG.COM00WLEAS",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG.COM12PURP30",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG.COM12PURP20",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG.COM12PURP25",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.COM12LOUDSPEAKER2",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG.COM12PURP10",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG.COM12PURP15",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_KAMPANJE_30GB.COM12VPL",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.DATA1GBA",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.REGULAR",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.COM00WLEAS",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_KAMPANJE_30GB.REGULAR",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG.TLF12PLEAS",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG.REGULAR",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.COM12PURP10",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.COM12PURP15",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.COM12PURP20",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.COM12PURP25",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2025_2.COM12PURP30",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.REGULAR",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.TLF12PLEAS",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.COM00ANSATT",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.COM00WLEAS",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.COM12LOUDSPEAKER2",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.COM12PURP10",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.COM12PURP15",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.COM12PURP20",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.COM12PURP25",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.COM12PURP30",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_15GB_2027.DATA1GBA",
        monthlyPrice: 399,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_12GB.DATA1GBA",
        monthlyPrice: 409,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_12GB.REGULAR",
        monthlyPrice: 409,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_12GB.COM12PURP15",
        monthlyPrice: 409,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_12GB.COM12PURP10",
        monthlyPrice: 409,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_12GB.COM12PURP25",
        monthlyPrice: 409,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_12GB.COM12PURP20",
        monthlyPrice: 409,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_12GB.COM12PURP30",
        monthlyPrice: 409,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.COM00WLEAS",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.COM12PURP15",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.COM12PURP10",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.COM12PURP30",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.COM12PURP25",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.COM12PURP20",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.REGULAR",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.DATA1GBA",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.COM00ANSATT",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_10GB_2026.TLF12PLEAS",
        monthlyPrice: 419,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2025_2.COM12LOUDSPEAKER2",
        monthlyPrice: 429,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2025_2.TLF12PLEAS",
        monthlyPrice: 429,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2025_2.COM12PURP30",
        monthlyPrice: 429,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2025_2.COM12PURP25",
        monthlyPrice: 429,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2025_2.COM12PURP20",
        monthlyPrice: 429,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2025_2.COM12PURP15",
        monthlyPrice: 429,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2025_2.COM12PURP10",
        monthlyPrice: 429,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2025_2.COM00WLEAS",
        monthlyPrice: 429,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2025_2.REGULAR",
        monthlyPrice: 429,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START.TLF12PLEAS",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2026.COM00WLEAS",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2026.REGULAR",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2026.TLF12PLEAS",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START.COM12ANSATT",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START.COM12PURP20",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START.COM12PURP25",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START.COM12PURP30",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START.COM12PURP10",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START.COM12PURP15",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2026.COM12PURP15",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2026.COM12PURP10",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2026.COM12PURP30",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2026.COM12PURP20",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_UNG_2026.COM12PURP25",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START.COM12LOUDSPEAKER2",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START.COM00WLEAS",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START.REGULAR",
        monthlyPrice: 449,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2025.COM12LOUDSPEAKER2",
        monthlyPrice: 479,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2025.REGULAR",
        monthlyPrice: 479,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2025.COM12ANSATT",
        monthlyPrice: 479,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2025.COM00WLEAS",
        monthlyPrice: 479,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2025.COM12PURP15",
        monthlyPrice: 479,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2025.COM12PURP10",
        monthlyPrice: 479,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2025.COM12PURP25",
        monthlyPrice: 479,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2025.COM12PURP20",
        monthlyPrice: 479,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2025.COM12PURP30",
        monthlyPrice: 479,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2025.TLF12PLEAS",
        monthlyPrice: 479,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_KAMPANJE_2026_2.TLF12PLEAS",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_KAMPANJE_2026_2.COM12KR3",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_KAMPANJE_2026_2.REGULAR",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_KAMPANJE_2026_2.COM12LOUDSPEAKER2",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2026.COM00WLEAS",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025.COM12LOUDSPEAKER2",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025.TLF12PLEAS",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2026.REGULAR",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2026.COM00ANSATT",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025.REGULAR",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2026.TLF12PLEAS",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025.COM00WLEAS",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2026.COM12PURP10",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2026.COM12PURP15",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2026.COM12PURP25",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2026.COM12PURP20",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025.COM12PURP15",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025.COM12PURP20",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025.COM12PURP25",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025.COM12PURP30",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025.COM12PURP10",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2026.COM12PURP30",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025.COM12ANSATT",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT.REGULAR",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT.COM00WLEAS",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT.COM12LOUDSPEAKER2",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT.TLF12PLEAS",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT.COM12KR3",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT.COM12KR4",
        monthlyPrice: 499,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT_2026.REGULAR",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT_2026.COM00WLEAS",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT_2026.TLF12PLEAS",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT_2026.COM12KR3",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_MOBIL_X_RASK_VT_2026.COM12KR4",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025_2.COM12PURP20",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025_2.COM12PURP25",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025_2.COM12PURP30",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025_2.COM12PURP10",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025_2.COM12PURP15",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025_2.COM12ANSATT",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_KAMPANJE.REGULAR",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_KAMPANJE.COM12KR1",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_INTRO+PROMO_INTRO_02_199.REGULAR",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_INTRO.REGULAR",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025_2.TLF12PLEAS",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025_2.COM00WLEAS",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025_2.REGULAR",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2025_2.COM12LOUDSPEAKER2",
        monthlyPrice: 529,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_INTRO_2026+PROMO_INTRO_02_199.REGULAR",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2026.COM00ANSATT",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2026.COM12PURP10",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2026.COM12PURP15",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2026.COM12PURP20",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2026.COM12PURP25",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2026.COM12PURP30",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_KAMPANJE_2026.REGULAR",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2026.COM00WLEAS",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_INTRO_2026.REGULAR",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2026.TLF12PLEAS",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2026.REGULAR",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_KAMPANJE_2026.COM00KR1",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_KAMPANJE_2026.COM12KR1",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_KAMPANJE_2026.COM12KR2",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2027.REGULAR",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2027.TLF12PLEAS",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2027.COM00ANSATT",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2027.COM00WLEAS",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2027.COM12LOUDSPEAKER2",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2027.COM12PURP10",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2027.COM12PURP15",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2027.COM12PURP20",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2027.COM12PURP25",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_START_2027.COM12PURP30",
        monthlyPrice: 549,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_300.COM12PURP15",
        monthlyPrice: 559,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_300.COM12PURP10",
        monthlyPrice: 559,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_300.COM12PURP25",
        monthlyPrice: 559,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_300.COM12PURP20",
        monthlyPrice: 559,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_300.COM12PURP30",
        monthlyPrice: 559,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_300.REGULAR",
        monthlyPrice: 559,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_300.COM12ANSATT",
        monthlyPrice: 559,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_500.REGULAR",
        monthlyPrice: 579,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_500.COM12PURP15",
        monthlyPrice: 579,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_500.COM12PURP10",
        monthlyPrice: 579,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_500.COM12PURP25",
        monthlyPrice: 579,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_500.COM12PURP20",
        monthlyPrice: 579,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_500.COM12PURP30",
        monthlyPrice: 579,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2025.COM12PURP30",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2025.COM12PURP20",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2025.COM12PURP25",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2025.COM12PURP10",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2025.COM12PURP15",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2025.COM00WLEAS",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2025.COM12LOUDSPEAKER2",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2025.COM12ANSATT",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2025.REGULAR",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2025.TLF12PLEAS",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2027.REGULAR",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2027.TLF12PLEAS",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2027.COM00ANSATT",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2027.COM00WLEAS",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2027.COM12LOUDSPEAKER2",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2027.COM12PURP10",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2027.COM12PURP15",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2027.COM12PURP20",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2027.COM12PURP25",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_BASIC_2027.COM12PURP30",
        monthlyPrice: 599,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2026.REGULAR",
        monthlyPrice: 649,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2026.TLF12PLEAS",
        monthlyPrice: 649,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2026.COM00ANSATT",
        monthlyPrice: 649,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 649,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2026.COM00WLEAS",
        monthlyPrice: 649,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2026.COM12PURP20",
        monthlyPrice: 649,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2026.COM12PURP25",
        monthlyPrice: 649,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2026.COM12PURP10",
        monthlyPrice: 649,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2026.COM12PURP15",
        monthlyPrice: 649,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2026.COM12PURP30",
        monthlyPrice: 649,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.COM12ANSATT",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.COM12PURP25",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.COM12PURP20",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.COM12PURP30",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.TLF12PLEAS",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.COM12PURP15",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.COM12PURP10",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.COM12LOUDSPEAKER2",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.COM00WLEAS",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.REGULAR",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2025.COM12AMB",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2027.REGULAR",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2027.TLF12PLEAS",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2027.COM00ANSATT",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2027.COM00WLEAS",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2027.COM12LOUDSPEAKER2",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2027.COM12PURP10",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2027.COM12PURP15",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2027.COM12PURP20",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2027.COM12PURP25",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_2027.COM12PURP30",
        monthlyPrice: 699,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.COM00WLEAS",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.REGULAR",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.COM12LOUDSPEAKER2",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.COM00AMB",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.COM12PURP30",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.COM12PURP20",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.COM12PURP25",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.COM12PURP10",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.COM12PURP15",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.TLF12PLEAS",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2026.COM00ANSATT",
        monthlyPrice: 749,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.REGULAR",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.TLF12PLEAS",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.COM00ANSATT",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.COM00WLEAS",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.COM12LOUDSPEAKER2",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.COM12PURP10",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.COM12PURP15",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.COM12PURP20",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.COM12PURP25",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.COM12PURP30",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
    {
        offeringCode: "TELIA_X_MAX_PLUS_2027.COM00AMB",
        monthlyPrice: 799,
        discountGroup: "MHS_B2C",
    },
];
